import { StoreState } from "../../models/states/StoreState";
import { VariableErrorModel } from "../VariableErrorModel";
import { VariableType } from "../../models/enums/VariableType";
import { makeMentionsSelector } from "../../redux/selectors/mentions";
import { isNullOrEmpty } from "../../utils";
import { QuestionModel } from "../../models/QuestionModel";
import { getSettingBoolean, getSettingString } from "../../models/utilities/settingUtilities";

const inputRequiredKey = "INPUT_REQUIRED";
const inputRequiredValueTrue = true;

const answerRequiredKey = "AnswerRequired";
const answerRequiredValueSoftPrompt = "SoftPrompt";

const errorKey = "IncompleteAnswer";

export function doesVariableExistInErrors(variableName, state) {
    const { errorsByVariableName } = state.interview.validation;
    if (!errorsByVariableName || typeof errorsByVariableName !== "object") {
        return false;
    }

    return Object.prototype.hasOwnProperty.call(errorsByVariableName, variableName);
}

export default function softPrompt(
    question: QuestionModel,
    variable = question.variables.find((v) => v.type !== VariableType.Computed),
) {
    if (!variable) {
        return null;
    }
    const { name: variableName } = variable;

    const mentionsSelector = makeMentionsSelector(variableName);

    return (getState: () => StoreState): VariableErrorModel => {
        const {
            interview: {
                questionnaire,
                validation: { errorsByVariableName },
            },
        } = getState();

        const isInputRequired =
            getSettingBoolean(questionnaire, inputRequiredKey) === inputRequiredValueTrue;
        const isSoftPrompt =
            getSettingString(question, answerRequiredKey) === answerRequiredValueSoftPrompt;

        if (isInputRequired && isSoftPrompt) {
            const mentions = mentionsSelector(getState());
            const isValid = mentions?.some((m) => !isNullOrEmpty(m.value));
            if (!isValid) {
                const errors = errorsByVariableName[variableName] || [];
                const hasShownSoftPrompt = errors.some((error) => error.softPrompt);
                return {
                    variableName,
                    error: {
                        key: errorKey,
                        softPrompt: true,
                        isErrorNew: !hasShownSoftPrompt,
                    },
                };
            }
        }
        return null;
    };
}
